// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"styles_containerBox__331IT","contentBox":"styles_contentBox__qpPqX","buttonsBox":"styles_buttonsBox__2pb1p","logoBox":"styles_logoBox__3DjIb"};